import React from "react";
import {
  Box,
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";


const MenuWithTransition = () => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  return (
      <Stack spacing={2} p={3}>
        <Box>
          <Typography variant={"h6"} color={"text.primary"}>
            Change transition
          </Typography>
          <Typography variant={"body2"} color={"text.primary"}>
            Use a different transition. using Popover and menulist
          </Typography>
        </Box>
        <Box sx={{ width: "80%", alignSelf: "center" }}>
      <PreviewAndEditor
        language="js"
        title={"MenuList in Popover with Transition"}
        value={"import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper,} from '@mui/material;'\n\n\n\n"
            +"const [open, setOpen] = React.useState(false);\n" +
            "  const anchorRef = React.useRef(null);\n" +
            "\n" +
            "  const handleToggle = () => {\n" +
            "    setOpen((prevOpen) => !prevOpen);\n" +
            "  };\n" +
            "\n" +
            "  const handleClose = (event) => {\n" +
            "    if (anchorRef.current && anchorRef.current.contains(event.target)) {\n" +
            "      return;\n" +
            "    }\n" +
            "\n" +
            "    setOpen(false);\n" +
            "  };\n" +
            "\n" +
            "  function handleListKeyDown(event) {\n" +
            "    if (event.key === 'Tab') {\n" +
            "      event.preventDefault();\n" +
            "      setOpen(false);\n" +
            "    } else if (event.key === 'Escape') {\n" +
            "      setOpen(false);\n" +
            "    }\n" +
            "  }\n" +
            "\n" +
            "  // return focus to the button when we transitioned from !open -> open\n" +
            "  const prevOpen = React.useRef(open);\n" +
            "  React.useEffect(() => {\n" +
            "    if (prevOpen.current === true && open === false) {\n" +
            "      anchorRef.current.focus();\n" +
            "    }\n" +
            "\n" +
            "    prevOpen.current = open;\n" +
            "  }, [open]);\n\n\n" +
            "<Button\n" +
            "            ref={anchorRef}\n" +
            "            id=\"composition-button\"\n" +
            "            aria-controls={open ? 'composition-menu' : undefined}\n" +
            "            aria-expanded={open ? 'true' : undefined}\n" +
            "            aria-haspopup=\"true\"\n" +
            "            onClick={handleToggle}\n" +
            "        >\n" +
            "          Dashboard\n" +
            "        </Button>\n" +
            "        <Popper\n" +
            "            open={open}\n" +
            "            anchorEl={anchorRef.current}\n" +
            "            role={undefined}\n" +
            "            placement=\"bottom-start\"\n" +
            "            transition\n" +
            "            disablePortal\n" +
            "        >\n" +
            "          {({ TransitionProps, placement }) => (\n" +
            "              <Grow\n" +
            "                  {...TransitionProps}\n" +
            "                  style={{\n" +
            "                    transformOrigin:\n" +
            "                        placement === 'bottom-start' ? 'left top' : 'left bottom',\n" +
            "                  }}\n" +
            "              >\n" +
            "                <Paper>\n" +
            "                  <ClickAwayListener onClickAway={handleClose}>\n" +
            "                    <MenuList\n" +
            "                        autoFocusItem={open}\n" +
            "                        id=\"composition-menu\"\n" +
            "                        aria-labelledby=\"composition-button\"\n" +
            "                        onKeyDown={handleListKeyDown}\n" +
            "                    >\n" +
            "                      <MenuItem onClick={handleClose}>Profile</MenuItem>\n" +
            "                      <MenuItem onClick={handleClose}>My account</MenuItem>\n" +
            "                      <MenuItem onClick={handleClose}>Logout</MenuItem>\n" +
            "                    </MenuList>\n" +
            "                  </ClickAwayListener>\n" +
            "                </Paper>\n" +
            "              </Grow>\n" +
            "          )}\n" +
            "        </Popper>"}
      >
        <Button
            ref={anchorRef}
            id="composition-button"
            aria-controls={open ? 'composition-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
        >
          Dashboard
        </Button>
        <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
        >
          {({ TransitionProps, placement }) => (
              <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                        placement === 'bottom-start' ? 'left top' : 'left bottom',
                  }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                        autoFocusItem={open}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={handleClose}>Profile</MenuItem>
                      <MenuItem onClick={handleClose}>My account</MenuItem>
                      <MenuItem onClick={handleClose}>Logout</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
          )}
        </Popper>
      </PreviewAndEditor>
    </Box>
      </Stack>
  );
};

export default MenuWithTransition;
